<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadUser="loadUser"
      @loadSummary="loadSummary"
      @loadTable="loadTable"
      @loadTableBenefits="loadTableBenefits"
      @loadTableBenefitsOrdered="loadTableBenefitsOrdered"
      :includeAdmin="true"
    ></results-bar>

    <results-summary
      v-if="viewMode === 'summary'"
      :id="doc.id"
      :model="model"
      :lang="lang"
      :key="keyCounter"
    ></results-summary>
    <results-table-aggregated
      v-if="viewMode === 'table'"
      :id="doc.id"
      :model="model"
      :lang="lang"
      :key="keyCounter"
    ></results-table-aggregated>
    <results-table-benefits
      v-if="viewMode === 'table-benefits'"
      :id="doc.id"
      :model="model"
      :lang="lang"
      :key="keyCounter"
    ></results-table-benefits>
    <results-table-benefits-ordered
      v-if="viewMode === 'table-benefits-ordered'"
      :id="doc.id"
      :model="model"
      :lang="lang"
      :key="keyCounter"
    ></results-table-benefits-ordered>

    <results-user
      v-if="viewMode === 'user'"
      :key="currentUser"
      :uid="currentUser"
      :id="doc.id"
      :model="model"
      :lang="keyCounter"
    ></results-user>
  </div>
</template>

<script>
import {
  ResultsUser,
  ResultsBar,
  ResultsSummary,
  ResultsTableAggregated,
  ResultsTableBenefits,
  ResultsTableBenefitsOrdered,
} from "@/components/results/benefits";

export default {
  name: "BenefitsResults",
  props: {
    doc: {
      type: Object,
      default: null,
    },
    model: String,
    lang: {
      type: String,
      default: "exercise_benefits_brand",
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null,
      viewMode: "summary",
      keyCounter: 0,
    };
  },
  components: {
    ResultsUser,
    ResultsBar,
    ResultsSummary,
    ResultsTableAggregated,
    ResultsTableBenefits,
    ResultsTableBenefitsOrdered,
  },
  methods: {
    loadSummary() {
      this.currentUser = null;
      this.viewMode = "summary";
      this.keyCounter++;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.viewMode = "user";
      this.keyCounter++;
    },
    loadTable() {
      this.currentUser = null;
      this.viewMode = "table";
      this.keyCounter++;
    },
    loadTableBenefits() {
      this.currentUser = null;
      this.viewMode = "table-benefits";
      this.keyCounter++;
    },
    loadTableBenefitsOrdered() {
      this.currentUser = null;
      this.viewMode = "table-benefits-ordered";
      this.keyCounter++;
    },
  },
};
</script>
